var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetStarted8Cf2F3De(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 64,
    viewBox: "0 0 55 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14003 15.9336L0.164062 16.3239L19.2497 63.3518H20.3341L1.14003 15.9336Z",
    fill: "#94989B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0676 63.3514L2.65659 15.4453L1.78906 15.738L20.9832 63.3514H22.0676Z",
    fill: "#94989B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0733 1.58231C27.0721 -3.49124 20.7825 20.5106 2.78125 15.437C6.03448 23.5352 9.28772 31.5358 12.541 39.634C30.5422 44.7075 36.8318 20.7057 54.833 25.7793C51.5798 17.6811 48.3265 9.68049 45.0733 1.58231",
    fill: "#252117"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16016 15.93L1.81087 15.7349L1.16016 15.93Z",
    fill: "#D0D0D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0049 63.3482L1.8108 15.7349L1.16016 15.93L20.3542 63.3482H21.0049Z",
    fill: "#D0D0D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted8Cf2F3De);
export default __webpack_public_path__ + "static/media/getStarted.8cf2f3de.7f26174898163b8ff319582e8bc06a92.svg";
export { ForwardRef as ReactComponent };